module.exports = __webpack_public_path__ + "static/img/membership_activity.fedbb6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership_activity.png
// module id = IM9R
// module chunks = 1